module["exports"] = [
  "South East Queensland",
  "Wide Bay Burnett",
  "Margaret River",
  "Port Pirie",
  "Gippsland",
  "Elizabeth",
  "Barossa"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_au_ocker/address/region.js
 ** module id = 460
 ** module chunks = 0
 **/